export const NAME = 'login';
export const FIRST_STEP_FORM = 'first-step-form';
export const SECOND_STEP_FORM = 'second-step-form';
